import Vue from "vue";

import SnowInput from "./form/SnowInput.vue";
import SnowSelect from "./form/SnowSelect.vue";
import SnowButton from "./SnowButton.vue";
import SnowCheckbox from "./SnowCheckbox.vue";
import SnowCheckboxesDropdown from "./SnowCheckboxesDropdown.vue";
import SnowCheckboxGroup from "./SnowCheckboxGroup.vue";
import SnowInputFile from "./SnowInputFile.vue";
import SnowRadio from "./SnowRadio.vue";
import SnowSearch from "./SnowSearch.vue";
import SnowDataTable from "./dataTable/SnowDataTable.vue";
import SnowDataTableHeader from "./dataTable/SnowDataTableHeader.vue";
import SnowDatePicker from "./SnowDatePicker.vue";
import SnowPaginator from ".//SnowPaginator.vue";
import SnowIntegrationCard from "./integrations/SnowIntegrationCard.vue";
import SnowSwitch from "./SnowSwitch.vue";
import SnowLinksInputs from "./SnowLinksInputs.vue";
import snowTableEvents from "./dataTable/snowTableEvents.vue";
import SnowToast from "./SnowToast.vue";
import SnowDropdown from "./SnowDropdown.vue";
import SnowSteps from "./SnowSteps.vue";
import SnowDialog from "./SnowDialog.vue";
import SnowActionsDropdown from "./SnowActionsDropdown.vue";

Vue.component("snow-button", SnowButton);
Vue.component("snow-input-file", SnowInputFile);
Vue.component("snow-select", SnowSelect);
Vue.component("snow-checkbox", SnowCheckbox);
Vue.component("snow-checkbox-group", SnowCheckboxGroup);
Vue.component("snow-checkboxes-dropdown", SnowCheckboxesDropdown);
Vue.component("snow-radio", SnowRadio);
Vue.component("snow-input", SnowInput);
Vue.component("snow-search", SnowSearch);
Vue.component("snow-data-table", SnowDataTable);
Vue.component("snow-data-table-header", SnowDataTableHeader);
Vue.component("snow-date-picker", SnowDatePicker);
Vue.component("snow-paginator", SnowPaginator);
Vue.component("snow-integration-card", SnowIntegrationCard);
Vue.component("snow-switch", SnowSwitch);
Vue.component("snow-links-inputs", SnowLinksInputs);
Vue.component("snow-table-events", snowTableEvents);
Vue.component("snow-toast", SnowToast);
Vue.component("snow-dropdown", SnowDropdown);
Vue.component("snow-steps", SnowSteps);
Vue.component("snow-dialog", SnowDialog);
Vue.component("snow-actions-dropdown", SnowActionsDropdown);
